import styled from 'styled-components';
import MainCntStyled from '../ExtractionCnt/MainCnt.styled';

export default styled(MainCntStyled)`
  margin: 0;
`;
